// extracted by mini-css-extract-plugin
export default {"checkbox":"checkbox__2AEuf","indent":"indent__n5rj6"};